import BasePage from "@Scripts/Pages/BasePage";

export default class DestinationDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setNavigation()
    }

    public static setNavigation() {
        var distance = $(".page-navigation").offset().top,
            $window = $(window);

        $window.on("scroll", function () {
            if ($window.scrollTop() >= distance) {
                $(".page-navigation, .page-content").attr("data-fix", "true");
            } else {
                $(".page-navigation, .page-content").removeAttr("data-fix");
            }
        });
    };
}